// @ts-nocheck
/**
 * v0 by Vercel.
 * @see https://v0.dev/t/ONaXRLWB7TZ
 * Documentation: https://v0.dev/docs#integrating-generated-code-into-your-nextjs-app
 */
import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button"
import { Badge } from "@/components/ui/badge"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import TextField from '@mui/material/TextField';
import { TableHead, TableRow, TableHeader, TableCell, TableBody, Table } from "@/components/ui/table"
import { useAuth, useUser, useClerk, useOrganization } from '@/auth/clerkShim'
import locationStore from '@/store/locationStore';
import timeSlotStore from '@/store/timeSlotStore';
import useTournamentStore from '@/store/tournamentStore';
import useLeagueStore from '@/store/leagueStore';
import ShowModalButton from "@components/modal/show-modal-button";
import { toast } from "sonner";
import { useModal } from "@/components/modal/provider";
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import _, { add } from 'lodash';
import moment from 'moment';
import helpers from '@/utils/helpers';
import { useOutletContext } from "react-router-dom";
import { convertToDataGrid, DataTable } from '@components/DataTable/DataTable';
import { ColumnInterface } from '@/interfaces';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  Select as UISelect,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  Table as UITable,
  TableBody as UITableBody,
  TableCell as UITableCell,
  TableHead as UITableHead,
  TableHeader as UITableHeader,
  TableRow as UITableRow,
} from "@/components/ui/table";
import { Separator } from "@/components/ui/separator";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import {
  MapPin, 
  Plus, 
  Calendar, 
  Clock, 
  Building2,
  Edit,
  Trash2,
  Save,
  X,
  CheckCircle,
  AlertCircle,
  ChevronDown,
  ChevronRight,
  Layers
} from 'lucide-react';
import { organizeLocationsHierarchy, flattenLocationsForSelect } from '@staty/shared/utils/getLocationDisplayName';
import { PageContainer, PageHeader } from '@/components/Page/PageContainer';
import QuickAvailabilityWizard, { type WizardCompetition } from '@/components/QuickAvailabilityWizard/QuickAvailabilityWizard';
import { TableSkeleton } from '@/components/Page/PageSkeletons';

export default function LocationAdmin() {
  const { user } = useUser();
  const modal = useModal();
  const { league: organization } = useOutletContext() as any;
  const { getToken, ...rest } = useAuth();
  const [ memberships, setMemberships ] = useState([]);
  const [ invitations, setInvitations ] = useState([]);
  const [ selectedLocation, setSelectedLocation ] = useState('');
  
  const { leagueName = '' } = useOutletContext() as any;
  const [ email, setEmail ] = useState('');
  const role = _.get(user, 'organizationMemberships[0].role', 'org:member');
  const isAdmin = role === 'org:admin';

  const { locations, addLocation, updateLocation, deleteLocation, getLocationsByLeagueName } = locationStore((state) => ({
    locations: state.locations,
    addLocation: state.addLocation(getToken),
    updateLocation: state.updateLocations(getToken),
    deleteLocation: state.deleteLocation(getToken),
    getLocationsByLeagueName: state.getLocationsByLeagueName,
  }));

  const { timeSlots, addTimeSlot, getTimeSlotsByLeagueName, updateTimeSlots, deleteTimeSlot } = timeSlotStore((state) => ({
    timeSlots: state.timeSlots,
    addTimeSlot: state.addTimeSlot(getToken),
    updateTimeSlots: state.updateTimeSlots(getToken),
    deleteTimeSlot: state.deleteTimeSlot(getToken),
    getTimeSlotsByLeagueName: state.getTimeSlotsByLeagueName,
  }));

  const { tournaments, getTournamentsByLeagueName } = useTournamentStore((state: any) => ({
    tournaments: state.tournaments,
    getTournamentsByLeagueName: state.getTournamentsByLeagueName,
  }));

  const { seasons, getSeasonsByLeagueName } = useLeagueStore((state: any) => ({
    seasons: state.leagues,
    getSeasonsByLeagueName: state.getLeaguesByOrganizationName,
  }));
  // INT-0027 quick availability from the venues page: competition picker over
  // standalone seasons + tournaments.
  const [quickOpen, setQuickOpen] = useState(false);
  const quickCompetitions: WizardCompetition[] = [
    ...(seasons || []).filter((l: any) => !l.tournament).map((l: any) => ({ kind: 'league' as const, id: l._id, name: l.name || 'Season' })),
    ...(tournaments || []).map((t: any) => ({ kind: 'tournament' as const, id: t._id, name: t.name || 'Tournament' })),
  ];

  // Skeleton only until the FIRST fetch round resolves — with cached store data
  // (module-singleton Zustand stores persist across navigations) content paints
  // immediately and refreshes silently.
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    Promise.all([
      getLocationsByLeagueName(leagueName),
      getTimeSlotsByLeagueName(leagueName),
      getTournamentsByLeagueName({ leagueName }),
      getSeasonsByLeagueName(leagueName),
    ]).finally(() => setLoaded(true));
    console.log('getLocationsByLeagueName::useEffect::leagueName', leagueName);
  }, []);
  console.log('Component::memberships', memberships);
  console.log('Component::locations', locations);
  console.log('Component::timeSlots', timeSlots);
  console.log('Component::league', organization);


  const [newTimeSlot, setNewTimeSlot] = useState({
    availableDate: moment(new Date()).format('MM-DD-YYYY'),
    startTime: "09:00",
    endTime: "15:00",
    gameDurationInMinutes: 60,
    contestType: "season", // default to season
    tournament: "",
    season: "",
  })

  const onSave = (data) => {
    const form = {
      ...data,
      organization: _.get(organization, '_id'),
    }
    console.log('onSave::', form);
    addLocation(form);
    // modal.close();
  };
  const handleInputChange = (e) => {
    setNewTimeSlot({ ...newTimeSlot, [e.target.name]: e.target.value })
  }
  const handleAddAvailability = () => {
    // Validate that either tournament or season is selected
    if (!newTimeSlot.tournament && !newTimeSlot.season) {
      toast.error("Please select either a tournament or season");
      return;
    }

    // Clean up the form data - remove empty fields and ensure only one contest type is set
    const cleanedTimeSlot: any = {
      availableDate: newTimeSlot.availableDate,
      startTime: newTimeSlot.startTime,
      endTime: newTimeSlot.endTime,
      gameDurationInMinutes: newTimeSlot.gameDurationInMinutes || 60,
      contestType: newTimeSlot.contestType,
      organization: _.get(organization, '_id'),
      location: selectedLocation,
    };

    // Only include the relevant field based on contest type
    if (newTimeSlot.contestType === "tournament" && newTimeSlot.tournament) {
      cleanedTimeSlot.tournament = newTimeSlot.tournament;
    } else if (newTimeSlot.contestType === "season" && newTimeSlot.season) {
      cleanedTimeSlot.season = newTimeSlot.season;
    }

    console.log('handleAddAvailability::cleanedTimeSlot::', cleanedTimeSlot);
    addTimeSlot(cleanedTimeSlot);
    
    setNewTimeSlot({
      availableDate: moment(new Date()).format('MM-DD-YYYY'),
      startTime: "09:00",
      endTime: "15:00",
      gameDurationInMinutes: 60,
      contestType: "season",
      tournament: "",
      season: "",
    })
  }

  const [isAddLocationOpen, setIsAddLocationOpen] = useState(false);
  const [isAddAvailabilityOpen, setIsAddAvailabilityOpen] = useState(false);
  const [isAddSubVenueOpen, setIsAddSubVenueOpen] = useState(false);
  const [isEditLocationOpen, setIsEditLocationOpen] = useState(false);
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [editingLocation, setEditingLocation] = useState(null);
  const [deletingLocation, setDeletingLocation] = useState(null);
  const [selectedParentVenue, setSelectedParentVenue] = useState(null);
  const [expandedVenues, setExpandedVenues] = useState<Set<string>>(new Set());
  
  // Filter states for availability table
  const [availabilityFilters, setAvailabilityFilters] = useState({
    contestType: "all", // "all", "season", "tournament"
    tournament: "",
    season: "",
  });

  const [newLocation, setNewLocation] = useState({
    name: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: '',
    capacity: '',
    description: ''
  });

  const [newSubVenue, setNewSubVenue] = useState({
    name: '',
    capacity: '',
    description: ''
  });

  // Organize locations into hierarchical structure
  const topLevelVenues = locations.filter(loc => !loc.parentLocation);
  const getSubVenues = (parentId) => locations.filter(loc => {
    const parentLocationId = typeof loc.parentLocation === 'object' 
      ? loc.parentLocation?._id 
      : loc.parentLocation;
    return parentLocationId === parentId;
  });

  const toggleVenueExpanded = (venueId) => {
    setExpandedVenues(prev => {
      const newSet = new Set(prev);
      if (newSet.has(venueId)) {
        newSet.delete(venueId);
      } else {
        newSet.add(venueId);
      }
      return newSet;
    });
  };

  const openAddSubVenueModal = (parentVenue) => {
    setSelectedParentVenue(parentVenue);
    setIsAddSubVenueOpen(true);
  };

  const handleSubVenueInputChange = (e) => {
    setNewSubVenue({ ...newSubVenue, [e.target.name]: e.target.value });
  };

  const onSaveSubVenue = () => {
    if (!selectedParentVenue || !newSubVenue.name) {
      toast.error("Please enter a sub-venue name");
      return;
    }
    const form = {
      name: newSubVenue.name,
      capacity: newSubVenue.capacity,
      description: newSubVenue.description,
      parentLocation: selectedParentVenue._id,
      organization: _.get(organization, '_id'),
    };
    console.log('onSaveSubVenue::', form);
    addLocation(form);
    setIsAddSubVenueOpen(false);
    setSelectedParentVenue(null);
    setNewSubVenue({ name: '', capacity: '', description: '' });
    // Auto-expand the parent venue to show the new sub-venue
    setExpandedVenues(prev => new Set(prev).add(selectedParentVenue._id));
  };

  // Edit location handlers
  const openEditLocationModal = (location) => {
    setEditingLocation({
      ...location,
      capacity: location.capacity || '',
      description: location.description || '',
    });
    setIsEditLocationOpen(true);
  };

  const handleEditLocationInputChange = (e) => {
    setEditingLocation({ ...editingLocation, [e.target.name]: e.target.value });
  };

  const onUpdateLocation = async () => {
    if (!editingLocation || !editingLocation.name) {
      toast.error("Please enter a venue name");
      return;
    }
    await updateLocation(editingLocation);
    setIsEditLocationOpen(false);
    setEditingLocation(null);
    // Refresh locations to get updated data
    getLocationsByLeagueName(leagueName);
  };

  // Delete location handlers
  const openDeleteConfirmModal = (location) => {
    setDeletingLocation(location);
    setIsDeleteConfirmOpen(true);
  };

  const onConfirmDelete = async () => {
    if (!deletingLocation) return;
    
    // Check if this venue has sub-venues
    const subVenues = getSubVenues(deletingLocation._id);
    if (subVenues.length > 0) {
      toast.error(`Cannot delete "${deletingLocation.name}" - it has ${subVenues.length} sub-venue(s). Delete sub-venues first.`);
      setIsDeleteConfirmOpen(false);
      setDeletingLocation(null);
      return;
    }
    
    await deleteLocation(deletingLocation._id);
    setIsDeleteConfirmOpen(false);
    setDeletingLocation(null);
  };

  // Get flattened locations for select dropdowns (venues and sub-venues)
  const flattenedLocations = flattenLocationsForSelect(locations);

  // DataTable handlers
  const onUpdateTimeSlot = async (newData) => {
    console.log('onUpdateTimeSlot::newData::', newData);
    // Convert location name to ID
    const locationName = newData.location;
    const location = _.find(locations, { name: locationName });
    const locationId = location ? location._id : newData.location;
    
    // Ensure the data has the league ID and location ID
    const updatedData = {
      ...newData,
      location: locationId,
      organization: _.get(organization, '_id'),
    };
    
    // The updateTimeSlots is already bound with getToken, so we call it directly
    return await updateTimeSlots(updatedData);
  };

  const onAddTimeSlot = async (newData) => {
    console.log('onAddTimeSlot::newData::', newData);
    
    // Convert location name to ID
    const locationName = newData.location;
    const location = _.find(locations, { name: locationName });
    const locationId = location ? location._id : newData.location;
    
    // Ensure the data has the league ID and location ID
    const newTimeSlot = {
      ...newData,
      location: locationId,
      organization: _.get(organization, '_id'),
    };
    
    // The addTimeSlot is already bound with getToken, so we call it directly
    return await addTimeSlot(newTimeSlot);
  };

  const onDeleteTimeSlot = async (id) => {
    console.log('onDeleteTimeSlot::id::', id);
    
    // The deleteTimeSlot is already bound with getToken, so we call it directly
    return await deleteTimeSlot(id);
  };

  // Column definitions for availability DataTable
  // Use flattened location names with parent-child combined names for sub-venues
  const locationValues = flattenedLocations.map(loc => loc.displayName);
  const availabilityColumns: ColumnInterface[] = [
    { 
      field: "location", 
      headerName: "Venue / Court", 
      type: 'singleSelect', 
      editable: true, 
      width: 250,
      valueOptions: locationValues,
      renderCell: (params) => {
        const locationName = params.value;
        // If the value is already a display name, use it directly
        if (locationName && locationValues.includes(locationName)) {
          return locationName;
        }
        // Otherwise, get the display name from the location ID
        return getLocationName(helpers.getObjId(params.value));
      },
    },
    {
      field: "availableDate", 
      headerName: "Date", 
      type: 'string', 
      editable: true, 
      width: 150,
      renderCell: (params) => formatDate(params.value)
    },
    {
      field: "startTime", 
      headerName: "Start Time", 
      type: 'string', 
      editable: true, 
      width: 120,
      renderCell: (params) => formatTime(params.value)
    },
    {
      field: "endTime", 
      headerName: "End Time", 
      type: 'string', 
      editable: true, 
      width: 120,
      renderCell: (params) => formatTime(params.value)
    },
    {
      field: "contestType", 
      headerName: "Contest Type", 
      type: 'string', 
      editable: true, 
      width: 150,
      renderCell: (params) => (
        <Badge variant={params.value === "tournament" ? "secondary" : "default"}>
          {params.value === "tournament" ? "Tournament" : params.value === "season" ? "Season" : "Unknown"}
        </Badge>
      )
    },
    {
      field: "tournamentSeason", 
      headerName: "Tournament/Season", 
      type: 'string', 
      editable: false, 
      width: 200,
      renderCell: (params) => {
        if (params.row.tournament) {
          return <span className="text-sm text-muted-foreground">{getTournamentName(helpers.getObjId(params.row.tournament))}</span>;
        } else if (params.row.season) {
          return <span className="text-sm text-muted-foreground">{getLeagueName(helpers.getObjId(params.row.season))}</span>;
        } else {
          return <span className="text-sm text-muted-foreground/60">Not assigned</span>;
        }
      }
    },
    {
      field: "status", 
      headerName: "Status", 
      type: 'string', 
      editable: false, 
      width: 120,
      renderCell: () => <Badge variant="default">Available</Badge>
    }
  ];

  const onSaveLocation = (data) => {
    const form = {
      ...data,
      organization: _.get(organization, '_id'),
    };
    console.log('onSaveLocation::', form);
    addLocation(form);
    setIsAddLocationOpen(false);
    setNewLocation({
      name: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      zipCode: '',
      capacity: '',
      description: ''
    });
  };

  const handleLocationInputChange = (e) => {
    setNewLocation({ ...newLocation, [e.target.name]: e.target.value });
  };

  const getLocationName = (locationId) => {
    const location = _.find(locations, { _id: helpers.getObjId(locationId) });
    console.log('getLocationName::location::', location, locations, locationId);
    console.log(`getLocationName::locationId:: ${locationId}`);
    if (!location) return 'Unknown Location';
    
    // Check if this is a sub-venue with a parent
    if (location.parentLocation) {
      const parentId = typeof location.parentLocation === 'object' 
        ? location.parentLocation._id 
        : location.parentLocation;
      const parent = _.find(locations, { _id: helpers.getObjId(parentId) });
      if (parent) {
        return `${parent.name} - ${location.name}`;
      }
    }
    return location.name;
  };

  const getTournamentName = (tournamentId) => {
    const tournament = _.find(tournaments, { _id: helpers.getObjId(tournamentId) });
    return tournament ? tournament.name : 'Unknown Tournament';
  };

  const getLeagueName = (leagueId) => {
    const season = _.find(seasons, { _id: helpers.getObjId(leagueId) });
    return season ? season.name : 'Unknown Season';
  };

  const formatTime = (time) => {
    return moment(time, 'HH:mm').format('h:mm A');
  };

  const formatDate = (date) => {
    // Handle MM-DD-YYYY format
    if (typeof date === 'string' && date.includes('-') && date.length === 10) {
      const [month, day, year] = date.split('-');
      const dateObj = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
      return moment(dateObj).format('MMM DD, YYYY');
    }
    return moment(date).format('MMM DD, YYYY');
  };

  // Filter timeSlots based on selected filters
  const getFilteredTimeSlots = () => {
    if (availabilityFilters.contestType === "all") {
      return timeSlots;
    }
    
    return timeSlots.filter(slot => {
      if (availabilityFilters.contestType === "tournament") {
        // If no specific tournament selected, show all tournament slots
        if (!availabilityFilters.tournament) {
          return slot.tournament; // Show slots that have any tournament
        }
        // If specific tournament selected, filter by that tournament
        return slot.tournament && slot.tournament === availabilityFilters.tournament;
      } else if (availabilityFilters.contestType === "season") {
        // If no specific season selected, show all season slots
        if (!availabilityFilters.season) {
          return slot.season; // Show slots that have any season
        }
        // If specific season selected, filter by that season
        return slot.season && slot.season === availabilityFilters.season;
      }
      return true;
    });
  };

  const filteredTimeSlots = getFilteredTimeSlots();

  // Convert location IDs to display names (including parent-child combined names)
  const processedTimeSlots = filteredTimeSlots.map(slot => {
    const locationId = helpers.getObjId(slot.location);
    return {
      ...slot,
      location: getLocationName(locationId)
    };
  });

  return (
    <PageContainer>
        {/* Header */}
        <PageHeader
          title="Venue Management"
          description="Manage your league venues and availability schedules"
          actions={(
            <>
              <Button variant="outline" size="lg" onClick={() => setIsAddLocationOpen(true)}>
                <Plus className="h-4 w-4 mr-2" />
                Add Venue
              </Button>
              <Button size="lg" variant="outline" onClick={() => setQuickOpen(true)} data-tour="locations-quick-availability">
                <Calendar className="h-4 w-4 mr-2" />
                Quick availability
              </Button>
              <Button size="lg" onClick={() => setIsAddAvailabilityOpen(true)}>
                <Calendar className="h-4 w-4 mr-2" />
                Add Availability
              </Button>
            </>
          )}
        />
        <QuickAvailabilityWizard
          open={quickOpen}
          onOpenChange={setQuickOpen}
          organization={organization}
          competitions={quickCompetitions}
          onDone={() => { if (leagueName) getTimeSlotsByLeagueName(leagueName); }}
        />

        {/* Main Content */}
        <Tabs defaultValue="venues" className="space-y-6">
          <TabsList className="grid w-full grid-cols-2 bg-muted shadow-sm">
            <TabsTrigger value="venues" className="flex items-center gap-2">
              <Building2 className="h-4 w-4" />
              Venues
            </TabsTrigger>
            <TabsTrigger value="availability" className="flex items-center gap-2">
              <Calendar className="h-4 w-4" />
              Availability
            </TabsTrigger>
          </TabsList>

          {/* Venues Tab */}
          <TabsContent value="venues" className="space-y-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Venues Overview */}
              <Card className="shadow-sm border-0">
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <Building2 className="h-5 w-5" />
                    Venues Overview
                  </CardTitle>
                  <CardDescription>Manage your league venues and locations</CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div className="grid grid-cols-2 gap-3">
                    <div className="flex items-center justify-between p-3 bg-muted/50 rounded-lg">
                      <div>
                        <p className="text-sm font-medium">Venues</p>
                        <p className="text-xs text-muted-foreground">Top-level locations</p>
                      </div>
                      <Badge variant="default" className="text-lg px-3 py-1">
                        {topLevelVenues.length}
                      </Badge>
                    </div>
                    <div className="flex items-center justify-between p-3 bg-primary/10 rounded-lg">
                      <div>
                        <p className="text-sm font-medium">Sub-Venues</p>
                        <p className="text-xs text-muted-foreground">Courts/Fields</p>
                      </div>
                      <Badge variant="secondary" className="text-lg px-3 py-1">
                        {locations.length - topLevelVenues.length}
                      </Badge>
                    </div>
                  </div>
                  
                  <div className="space-y-3">
                    {topLevelVenues.slice(0, 3).map((location) => {
                      const subVenues = getSubVenues(location._id);
                      return (
                        <div key={location._id} className="p-3 bg-muted/50 rounded-lg">
                          <div className="flex items-center justify-between">
                            <div>
                              <p className="text-sm font-medium">{location.name}</p>
                              <p className="text-xs text-muted-foreground">{location.address1}</p>
                            </div>
                            <div className="flex items-center gap-2">
                              {subVenues.length > 0 && (
                                <Badge variant="outline" className="text-xs">
                                  {subVenues.length} sub-venue{subVenues.length !== 1 ? 's' : ''}
                                </Badge>
                              )}
                              <Button 
                                variant="outline" 
                                size="sm"
                                aria-label="Edit venue"
                                onClick={() => openEditLocationModal(location)}
                              >
                                <Edit className="h-3 w-3" />
                              </Button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  
                  {/* Never flash the empty state while the initial fetch is in flight */}
                  {loaded && locations.length === 0 && (
                    <div className="text-center py-8">
                      <Building2 className="h-12 w-12 mx-auto text-muted-foreground/60 mb-4" />
                      <p className="text-sm text-muted-foreground mb-2">No venues configured</p>
                      <p className="text-xs text-muted-foreground/60">Add your first venue to get started</p>
                    </div>
                  )}
                </CardContent>
              </Card>

              {/* Quick Stats */}
              <Card className="shadow-sm border-0">
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <MapPin className="h-5 w-5" />
                    Quick Stats
                  </CardTitle>
                  <CardDescription>Venue utilization and availability</CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div className="grid grid-cols-3 gap-4">
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <p className="text-sm font-medium text-primary-deep">Time Slots</p>
                      <p className="text-2xl font-bold text-primary">{timeSlots.length}</p>
                    </div>
                    <div className="p-3 bg-success/10 rounded-lg">
                      <p className="text-sm font-medium text-success">Venues</p>
                      <p className="text-2xl font-bold text-success">{topLevelVenues.length}</p>
                    </div>
                    <div className="p-3 bg-primary/10 rounded-lg">
                      <p className="text-sm font-medium text-primary-deep">Sub-Venues</p>
                      <p className="text-2xl font-bold text-primary">{locations.length - topLevelVenues.length}</p>
                    </div>
                  </div>
                  
                  <Separator />
                  
                  <div className="space-y-2">
                    <p className="text-sm font-medium">Recent Activity</p>
                    <div className="space-y-1">
                      {timeSlots.slice(0, 3).map((slot, index) => (
                        <div key={index} className="flex items-center gap-2 text-xs text-muted-foreground">
                          <CheckCircle className="h-3 w-3 text-success" />
                          <span>Added availability for {getLocationName(helpers.getObjId(slot.location))}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Venues Table */}
            <Card className="shadow-sm border-0">
              <CardHeader>
                <CardTitle>All Venues</CardTitle>
                <CardDescription>Complete list of league venues, sub-venues (courts/fields), and their details</CardDescription>
              </CardHeader>
              <CardContent>
                {/* Table skeleton during the FIRST load when no venues are cached */}
                {!loaded && locations.length === 0 ? (
                <TableSkeleton rows={5} columns={5} />
                ) : (
                <UITable>
                  <UITableHeader>
                    <UITableRow>
                      <UITableHead className="w-8"></UITableHead>
                      <UITableHead>Venue Name</UITableHead>
                      <UITableHead>Address</UITableHead>
                      <UITableHead>Sub-Venues</UITableHead>
                      <UITableHead>Capacity</UITableHead>
                      <UITableHead>Status</UITableHead>
                      <UITableHead>Actions</UITableHead>
                    </UITableRow>
                  </UITableHeader>
                  <UITableBody>
                    {topLevelVenues.map((location) => {
                      const subVenues = getSubVenues(location._id);
                      const isExpanded = expandedVenues.has(location._id);
                      
                      return (
                        <React.Fragment key={location._id}>
                          {/* Parent Venue Row */}
                          <UITableRow className="bg-card hover:bg-muted/50">
                            <UITableCell className="w-8 p-2">
                              {subVenues.length > 0 ? (
                                <Button 
                                  variant="ghost" 
                                  size="sm" 
                                  className="h-6 w-6 p-0"
                                  onClick={() => toggleVenueExpanded(location._id)}
                                >
                                  {isExpanded ? (
                                    <ChevronDown className="h-4 w-4" />
                                  ) : (
                                    <ChevronRight className="h-4 w-4" />
                                  )}
                                </Button>
                              ) : (
                                <div className="w-6" />
                              )}
                            </UITableCell>
                            <UITableCell className="font-medium">
                              <div className="flex items-center gap-2">
                                <Building2 className="h-4 w-4 text-muted-foreground/60" />
                                {location.name}
                              </div>
                            </UITableCell>
                            <UITableCell>{location.address1 || '-'}</UITableCell>
                            <UITableCell>
                              {subVenues.length > 0 ? (
                                <Badge variant="secondary" className="text-xs">
                                  {subVenues.length} court{subVenues.length !== 1 ? 's' : ''}
                                </Badge>
                              ) : (
                                <span className="text-muted-foreground/60 text-sm">None</span>
                              )}
                            </UITableCell>
                            <UITableCell>{location.capacity || 'N/A'}</UITableCell>
                            <UITableCell>
                              <Badge variant="default">Active</Badge>
                            </UITableCell>
                            <UITableCell>
                              <div className="flex items-center gap-2">
                                <Button 
                                  variant="outline" 
                                  size="sm"
                                  onClick={() => openAddSubVenueModal(location)}
                                  title="Add Sub-Venue"
                                >
                                  <Layers className="h-3 w-3 mr-1" />
                                  <Plus className="h-3 w-3" />
                                </Button>
                                <Button 
                                  variant="outline" 
                                  size="sm"
                                  onClick={() => openEditLocationModal(location)}
                                  title="Edit Venue"
                                >
                                  <Edit className="h-3 w-3" />
                                </Button>
                                <Button 
                                  variant="outline" 
                                  size="sm"
                                  onClick={() => openDeleteConfirmModal(location)}
                                  title="Delete Venue"
                                >
                                  <Trash2 className="h-3 w-3" />
                                </Button>
                              </div>
                            </UITableCell>
                          </UITableRow>
                          
                          {/* Sub-Venue Rows (expanded) */}
                          {isExpanded && subVenues.map((subVenue) => (
                            <UITableRow key={subVenue._id} className="bg-muted/30">
                              <UITableCell className="w-8 p-2"></UITableCell>
                              <UITableCell className="font-medium pl-8">
                                <div className="flex items-center gap-2">
                                  <Layers className="h-4 w-4 text-primary" />
                                  <span className="text-muted-foreground">{subVenue.name}</span>
                                </div>
                              </UITableCell>
                              <UITableCell className="text-muted-foreground text-sm">
                                <span className="italic">Inherits from parent</span>
                              </UITableCell>
                              <UITableCell>-</UITableCell>
                              <UITableCell>{subVenue.capacity || 'N/A'}</UITableCell>
                              <UITableCell>
                                <Badge variant="outline">Sub-venue</Badge>
                              </UITableCell>
                              <UITableCell>
                                <div className="flex items-center gap-2">
                                  <Button 
                                    variant="outline" 
                                    size="sm"
                                    onClick={() => openEditLocationModal(subVenue)}
                                    title="Edit Sub-Venue"
                                  >
                                    <Edit className="h-3 w-3" />
                                  </Button>
                                  <Button 
                                    variant="outline" 
                                    size="sm"
                                    onClick={() => openDeleteConfirmModal(subVenue)}
                                    title="Delete Sub-Venue"
                                  >
                                    <Trash2 className="h-3 w-3" />
                                  </Button>
                                </div>
                              </UITableCell>
                            </UITableRow>
                          ))}
                        </React.Fragment>
                      );
                    })}
                  </UITableBody>
                </UITable>
                )}
              </CardContent>
            </Card>
          </TabsContent>

          {/* Availability Tab */}
          <TabsContent value="availability" className="space-y-6">
            <div className="space-y-6">
              {/* Availability Overview */}
              <Card className="shadow-sm border-0">
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <Clock className="h-5 w-5" />
                    Availability Overview
                  </CardTitle>
                  <CardDescription>Upcoming venue availability</CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div className="flex items-center justify-between p-3 bg-muted/50 rounded-lg">
                    <div>
                      <p className="text-sm font-medium">Total Slots</p>
                      <p className="text-xs text-muted-foreground">Scheduled availability</p>
                    </div>
                    <Badge variant="default" className="text-lg px-3 py-1">
                      {timeSlots.length}
                    </Badge>
                  </div>
                  
                  <div className="space-y-3">
                    {filteredTimeSlots.slice(0, 5).map((slot, index) => (
                      <div key={index} className="flex items-center justify-between p-3 bg-muted/50 rounded-lg">
                        <div>
                          <p className="text-sm font-medium">{getLocationName(helpers.getObjId(slot.location))}</p>
                          <p className="text-xs text-muted-foreground">
                            {formatDate(slot.availableDate)} • {formatTime(slot.startTime)} - {formatTime(slot.endTime)}
                          </p>
                          <p className="text-xs text-muted-foreground/60">
                            {slot.tournament ? `Tournament: ${getTournamentName(helpers.getObjId(slot.tournament))}` : 
                             slot.season ? `Season: ${getLeagueName(helpers.getObjId(slot.season))}` : 
                             'Not assigned'}
                          </p>
                        </div>
                        <Badge variant="outline">Available</Badge>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Availability Table */}
            <Card className="shadow-sm border-0">
              <CardHeader>
                <div className="flex items-center justify-between">
                  <div>
                    <CardTitle>All Availability</CardTitle>
                    <CardDescription>Complete schedule of venue availability</CardDescription>
                  </div>
                  <div className="flex items-center gap-2">
                    <Badge variant="outline">
                      {filteredTimeSlots.length} of {timeSlots.length} slots
                    </Badge>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                {/* Filter Controls */}
                <div className="mb-6 p-4 bg-muted/50 rounded-lg">
                  <div className="flex items-center gap-4 flex-wrap">
                    <div className="space-y-2">
                      <Label htmlFor="filter-contest-type">Filter by Contest Type</Label>
                      <UISelect 
                        value={availabilityFilters.contestType} 
                        onValueChange={(value) => setAvailabilityFilters({ 
                          ...availabilityFilters, 
                          contestType: value, 
                          tournament: "", 
                          season: "" 
                        })}
                      >
                        <SelectTrigger id="filter-contest-type" className="w-48">
                          <SelectValue placeholder="All Types" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="all">All Types</SelectItem>
                          <SelectItem value="season">Season</SelectItem>
                          <SelectItem value="tournament">Tournament</SelectItem>
                        </SelectContent>
                      </UISelect>
                    </div>

                    {availabilityFilters.contestType === "tournament" && (
                      <div className="space-y-2">
                        <Label htmlFor="filter-tournament">Select Tournament</Label>
                        <UISelect 
                          value={availabilityFilters.tournament || "all"} 
                          onValueChange={(value) => setAvailabilityFilters({ 
                            ...availabilityFilters, 
                            tournament: value === "all" ? "" : value 
                          })}
                        >
                          <SelectTrigger id="filter-tournament" className="w-64">
                            <SelectValue placeholder="All Tournaments" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="all">All Tournaments</SelectItem>
                            {tournaments.map((tournament) => (
                              <SelectItem key={tournament._id} value={tournament._id}>
                                {tournament.name}
                              </SelectItem>
                            ))}
                          </SelectContent>
                        </UISelect>
                      </div>
                    )}

                    {availabilityFilters.contestType === "season" && (
                      <div className="space-y-2">
                        <Label htmlFor="filter-season">Select Season</Label>
                        <UISelect 
                          value={availabilityFilters.season || "all"} 
                          onValueChange={(value) => setAvailabilityFilters({ 
                            ...availabilityFilters, 
                            season: value === "all" ? "" : value 
                          })}
                        >
                          <SelectTrigger id="filter-season" className="w-64">
                            <SelectValue placeholder="All Seasons" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="all">All Seasons</SelectItem>
                            {seasons.filter(season => season.contestType === 'season').map((season) => (
                              <SelectItem key={season._id} value={season._id}>
                                {season.name}
                              </SelectItem>
                            ))}
                          </SelectContent>
                        </UISelect>
                      </div>
                    )}

                    <Button 
                      variant="outline" 
                      onClick={() => setAvailabilityFilters({ contestType: "all", tournament: "", season: "" })}
                      className="mt-6"
                    >
                      <X className="h-4 w-4 mr-2" />
                      Clear Filters
                    </Button>
                  </div>
                </div>
                
                <DataTable
                  columns={availabilityColumns}
                  config={{
                    pageSize: 25,
                  }}
                  dataList={convertToDataGrid(availabilityColumns, processedTimeSlots)}
                  onUpdate={onUpdateTimeSlot}
                  onAdd={onAddTimeSlot}
                  onDelete={onDeleteTimeSlot}
                />
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>

        {/* Add Location Modal */}
        <Dialog open={isAddLocationOpen} onOpenChange={setIsAddLocationOpen}>
          <DialogContent className="sm:max-w-[500px]">
            <DialogHeader>
              <DialogTitle>Add New Venue</DialogTitle>
              <DialogDescription>
                Add a new venue to your league. Fill in the details below.
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-4 py-4">
              <div className="space-y-2">
                <Label htmlFor="name">Venue Name</Label>
                <Input
                  id="name"
                  name="name"
                  value={newLocation.name}
                  onChange={handleLocationInputChange}
                  placeholder="Enter venue name"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="address1">Address Line 1</Label>
                <Input
                  id="address1"
                  name="address1"
                  value={newLocation.address1}
                  onChange={handleLocationInputChange}
                  placeholder="Enter street address"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="address2">Address Line 2</Label>
                <Input
                  id="address2"
                  name="address2"
                  value={newLocation.address2}
                  onChange={handleLocationInputChange}
                  placeholder="Apartment, suite, unit, etc. (optional)"
                />
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="space-y-2">
                  <Label htmlFor="city">City</Label>
                  <Input
                    id="city"
                    name="city"
                    value={newLocation.city}
                    onChange={handleLocationInputChange}
                    placeholder="City"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="state">State</Label>
                  <Input
                    id="state"
                    name="state"
                    value={newLocation.state}
                    onChange={handleLocationInputChange}
                    placeholder="State"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="zipCode">ZIP Code</Label>
                  <Input
                    id="zipCode"
                    name="zipCode"
                    value={newLocation.zipCode}
                    onChange={handleLocationInputChange}
                    placeholder="ZIP"
                  />
                </div>
              </div>
              <div className="space-y-2">
                <Label htmlFor="capacity">Capacity</Label>
                <Input
                  id="capacity"
                  name="capacity"
                  type="number"
                  value={newLocation.capacity}
                  onChange={handleLocationInputChange}
                  placeholder="Maximum capacity"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="description">Description</Label>
                <Input
                  id="description"
                  name="description"
                  value={newLocation.description}
                  onChange={handleLocationInputChange}
                  placeholder="Venue description"
                />
              </div>
            </div>
            <div className="flex justify-end gap-3">
              <Button variant="outline" onClick={() => setIsAddLocationOpen(false)}>
                Cancel
              </Button>
              <Button onClick={() => onSaveLocation(newLocation)}>
                <Save className="h-4 w-4 mr-2" />
                Save Venue
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        {/* Add Availability Modal */}
        <Dialog open={isAddAvailabilityOpen} onOpenChange={setIsAddAvailabilityOpen}>
          <DialogContent className="sm:max-w-[600px]">
            <DialogHeader>
              <DialogTitle>Add New Availability</DialogTitle>
              <DialogDescription>
                Schedule venue availability for games and events. Fill in the details below.
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-4 py-4">
              <div className="space-y-2">
                <Label htmlFor="modal-location-select">Select Venue or Court</Label>
                <UISelect value={selectedLocation} onValueChange={setSelectedLocation}>
                  <SelectTrigger id="modal-location-select">
                    <SelectValue placeholder="Choose a venue or court" />
                  </SelectTrigger>
                  <SelectContent>
                    {flattenedLocations.map((location) => (
                      <SelectItem 
                        key={location._id} 
                        value={location._id}
                        className={location.isSubVenue ? 'pl-6' : 'font-medium'}
                      >
                        {location.isSubVenue ? (
                          <span className="flex items-center gap-2">
                            <Layers className="h-3 w-3 text-primary" />
                            {location.displayName}
                          </span>
                        ) : (
                          <span className="flex items-center gap-2">
                            <Building2 className="h-3 w-3 text-muted-foreground/60" />
                            {location.displayName}
                          </span>
                        )}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </UISelect>
              </div>

              <div className="space-y-2">
                <Label htmlFor="modal-contest-type">Contest Type</Label>
                <UISelect 
                  value={newTimeSlot.contestType} 
                  onValueChange={(value) => setNewTimeSlot({ ...newTimeSlot, contestType: value, tournament: "", season: "" })}
                >
                  <SelectTrigger id="modal-contest-type">
                    <SelectValue placeholder="Choose contest type" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="season">Season</SelectItem>
                    <SelectItem value="tournament">Tournament</SelectItem>
                  </SelectContent>
                </UISelect>
              </div>

              {newTimeSlot.contestType === "tournament" && (
                <div className="space-y-2">
                  <Label htmlFor="modal-tournament-select">Select Tournament</Label>
                  <UISelect 
                    value={newTimeSlot.tournament} 
                    onValueChange={(value) => setNewTimeSlot({ ...newTimeSlot, tournament: value, season: "" })}
                  >
                    <SelectTrigger id="modal-tournament-select">
                      <SelectValue placeholder="Choose a tournament" />
                    </SelectTrigger>
                    <SelectContent>
                      {tournaments.map((tournament) => (
                        <SelectItem key={tournament._id} value={tournament._id}>
                          {tournament.name}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </UISelect>
                </div>
              )}

              {newTimeSlot.contestType === "season" && (
                <div className="space-y-2">
                  <Label htmlFor="modal-contest-select">Select Season</Label>
                  <UISelect 
                    value={newTimeSlot.season} 
                    onValueChange={(value) => setNewTimeSlot({ ...newTimeSlot, season: value, tournament: "" })}
                  >
                    <SelectTrigger id="modal-contest-select">
                      <SelectValue placeholder="Choose a season" />
                    </SelectTrigger>
                    <SelectContent>
                      {seasons.filter(season => season.contestType === 'season').map((season) => (
                        <SelectItem key={season._id} value={season._id}>
                          {season.name}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </UISelect>
                </div>
              )}

              <div className="grid grid-cols-3 gap-4">
                <div className="space-y-2">
                  <Label htmlFor="modal-availableDate">Date</Label>
                  <Input
                    id="modal-availableDate"
                    name="availableDate"
                    type="text"
                    value={newTimeSlot.availableDate}
                    onChange={handleInputChange}
                    placeholder="MM-DD-YYYY"
                    pattern="[0-9]{2}-[0-9]{2}-[0-9]{4}"
                    required
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="modal-startTime">Start Time</Label>
                  <Input
                    id="modal-startTime"
                    name="startTime"
                    type="time"
                    value={newTimeSlot.startTime}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="modal-endTime">End Time</Label>
                  <Input
                    id="modal-endTime"
                    name="endTime"
                    type="time"
                    value={newTimeSlot.endTime}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              <div className="space-y-2">
                <Label htmlFor="modal-gameDurationInMinutes">Game Duration (minutes)</Label>
                <Input
                  id="modal-gameDurationInMinutes"
                  name="gameDurationInMinutes"
                  type="number"
                  min="1"
                  value={newTimeSlot.gameDurationInMinutes}
                  onChange={(e) => setNewTimeSlot({ ...newTimeSlot, gameDurationInMinutes: parseInt(e.target.value) || 60 })}
                  placeholder="60"
                  required
                />
              </div>
            </div>
            <div className="flex justify-end gap-3">
              <Button variant="outline" onClick={() => setIsAddAvailabilityOpen(false)}>
                Cancel
              </Button>
              <Button 
                onClick={() => {
                  handleAddAvailability();
                  setIsAddAvailabilityOpen(false);
                }}
                disabled={!selectedLocation || (!newTimeSlot.tournament && !newTimeSlot.season)}
              >
                <Calendar className="h-4 w-4 mr-2" />
                Add Availability
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        {/* Add Sub-Venue Modal */}
        <Dialog open={isAddSubVenueOpen} onOpenChange={(open) => {
          setIsAddSubVenueOpen(open);
          if (!open) {
            setSelectedParentVenue(null);
            setNewSubVenue({ name: '', capacity: '', description: '' });
          }
        }}>
          <DialogContent className="sm:max-w-[400px]">
            <DialogHeader>
              <DialogTitle>Add Sub-Venue</DialogTitle>
              <DialogDescription>
                Add a court or field to <strong>{selectedParentVenue?.name}</strong>
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-4 py-4">
              <div className="p-3 bg-muted/50 rounded-lg">
                <p className="text-xs text-muted-foreground mb-1">Parent Venue</p>
                <p className="text-sm font-medium flex items-center gap-2">
                  <Building2 className="h-4 w-4 text-muted-foreground/60" />
                  {selectedParentVenue?.name}
                </p>
                {selectedParentVenue?.address1 && (
                  <p className="text-xs text-muted-foreground mt-1">{selectedParentVenue.address1}</p>
                )}
              </div>
              
              <div className="space-y-2">
                <Label htmlFor="subvenue-name">Sub-Venue Name</Label>
                <Input
                  id="subvenue-name"
                  name="name"
                  value={newSubVenue.name}
                  onChange={handleSubVenueInputChange}
                  placeholder="e.g., Court 1, Field A, Gym 2"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="subvenue-capacity">Capacity (optional)</Label>
                <Input
                  id="subvenue-capacity"
                  name="capacity"
                  type="number"
                  value={newSubVenue.capacity}
                  onChange={handleSubVenueInputChange}
                  placeholder="Maximum capacity"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="subvenue-description">Description (optional)</Label>
                <Input
                  id="subvenue-description"
                  name="description"
                  value={newSubVenue.description}
                  onChange={handleSubVenueInputChange}
                  placeholder="Additional details"
                />
              </div>
            </div>
            <div className="flex justify-end gap-3">
              <Button variant="outline" onClick={() => setIsAddSubVenueOpen(false)}>
                Cancel
              </Button>
              <Button onClick={onSaveSubVenue} disabled={!newSubVenue.name}>
                <Layers className="h-4 w-4 mr-2" />
                Add Sub-Venue
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        {/* Edit Location Modal */}
        <Dialog open={isEditLocationOpen} onOpenChange={(open) => {
          setIsEditLocationOpen(open);
          if (!open) {
            setEditingLocation(null);
          }
        }}>
          <DialogContent className="sm:max-w-[500px]">
            <DialogHeader>
              <DialogTitle>
                {editingLocation?.parentLocation ? 'Edit Sub-Venue' : 'Edit Venue'}
              </DialogTitle>
              <DialogDescription>
                Update the details for {editingLocation?.parentLocation ? 'this sub-venue' : 'this venue'}.
              </DialogDescription>
            </DialogHeader>
            {editingLocation && (
              <div className="space-y-4 py-4">
                {editingLocation.parentLocation && (
                  <div className="p-3 bg-muted/50 rounded-lg">
                    <p className="text-xs text-muted-foreground mb-1">Parent Venue</p>
                    <p className="text-sm font-medium flex items-center gap-2">
                      <Building2 className="h-4 w-4 text-muted-foreground/60" />
                      {typeof editingLocation.parentLocation === 'object' 
                        ? editingLocation.parentLocation.name 
                        : locations.find(l => l._id === editingLocation.parentLocation)?.name || 'Unknown'}
                    </p>
                  </div>
                )}
                
                <div className="space-y-2">
                  <Label htmlFor="edit-name">
                    {editingLocation.parentLocation ? 'Sub-Venue Name' : 'Venue Name'}
                  </Label>
                  <Input
                    id="edit-name"
                    name="name"
                    value={editingLocation.name || ''}
                    onChange={handleEditLocationInputChange}
                    placeholder={editingLocation.parentLocation ? 'e.g., Court 1, Field A' : 'Enter venue name'}
                  />
                </div>
                
                {!editingLocation.parentLocation && (
                  <>
                    <div className="space-y-2">
                      <Label htmlFor="edit-address1">Address Line 1</Label>
                      <Input
                        id="edit-address1"
                        name="address1"
                        value={editingLocation.address1 || ''}
                        onChange={handleEditLocationInputChange}
                        placeholder="Enter street address"
                      />
                    </div>
                    <div className="space-y-2">
                      <Label htmlFor="edit-address2">Address Line 2</Label>
                      <Input
                        id="edit-address2"
                        name="address2"
                        value={editingLocation.address2 || ''}
                        onChange={handleEditLocationInputChange}
                        placeholder="Apartment, suite, unit, etc. (optional)"
                      />
                    </div>
                    <div className="grid grid-cols-3 gap-4">
                      <div className="space-y-2">
                        <Label htmlFor="edit-city">City</Label>
                        <Input
                          id="edit-city"
                          name="city"
                          value={editingLocation.city || ''}
                          onChange={handleEditLocationInputChange}
                          placeholder="City"
                        />
                      </div>
                      <div className="space-y-2">
                        <Label htmlFor="edit-state">State</Label>
                        <Input
                          id="edit-state"
                          name="state"
                          value={editingLocation.state || ''}
                          onChange={handleEditLocationInputChange}
                          placeholder="State"
                        />
                      </div>
                      <div className="space-y-2">
                        <Label htmlFor="edit-zipCode">ZIP Code</Label>
                        <Input
                          id="edit-zipCode"
                          name="zipCode"
                          value={editingLocation.zipCode || ''}
                          onChange={handleEditLocationInputChange}
                          placeholder="ZIP"
                        />
                      </div>
                    </div>
                  </>
                )}
                
                <div className="space-y-2">
                  <Label htmlFor="edit-capacity">Capacity</Label>
                  <Input
                    id="edit-capacity"
                    name="capacity"
                    type="number"
                    value={editingLocation.capacity || ''}
                    onChange={handleEditLocationInputChange}
                    placeholder="Maximum capacity"
                  />
                </div>
              </div>
            )}
            <div className="flex justify-end gap-3">
              <Button variant="outline" onClick={() => setIsEditLocationOpen(false)}>
                Cancel
              </Button>
              <Button onClick={onUpdateLocation}>
                <Save className="h-4 w-4 mr-2" />
                Save Changes
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        {/* Delete Confirmation Modal */}
        <Dialog open={isDeleteConfirmOpen} onOpenChange={(open) => {
          setIsDeleteConfirmOpen(open);
          if (!open) {
            setDeletingLocation(null);
          }
        }}>
          <DialogContent className="sm:max-w-[400px]">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2 text-destructive">
                <AlertCircle className="h-5 w-5" />
                Confirm Delete
              </DialogTitle>
              <DialogDescription>
                Are you sure you want to delete this {deletingLocation?.parentLocation ? 'sub-venue' : 'venue'}?
              </DialogDescription>
            </DialogHeader>
            {deletingLocation && (
              <div className="py-4">
                <div className="p-4 bg-destructive/10 rounded-lg border border-destructive/30">
                  <p className="font-medium text-destructive flex items-center gap-2">
                    {deletingLocation.parentLocation ? (
                      <Layers className="h-4 w-4" />
                    ) : (
                      <Building2 className="h-4 w-4" />
                    )}
                    {deletingLocation.name}
                  </p>
                  {deletingLocation.address1 && (
                    <p className="text-sm text-destructive mt-1">{deletingLocation.address1}</p>
                  )}
                  {!deletingLocation.parentLocation && getSubVenues(deletingLocation._id).length > 0 && (
                    <p className="text-sm text-destructive mt-2 font-medium">
                      Warning: This venue has {getSubVenues(deletingLocation._id).length} sub-venue(s) that must be deleted first.
                    </p>
                  )}
                </div>
                <p className="text-sm text-muted-foreground mt-4">
                  This action cannot be undone. Any time slots associated with this location will need to be reassigned.
                </p>
              </div>
            )}
            <div className="flex justify-end gap-3">
              <Button variant="outline" onClick={() => setIsDeleteConfirmOpen(false)}>
                Cancel
              </Button>
              <Button 
                variant="destructive" 
                onClick={onConfirmDelete}
                disabled={deletingLocation && !deletingLocation.parentLocation && getSubVenues(deletingLocation._id).length > 0}
              >
                <Trash2 className="h-4 w-4 mr-2" />
                Delete
              </Button>
            </div>
          </DialogContent>
        </Dialog>
    </PageContainer>
  )
}

function BellIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
      <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
    </svg>
  )
}


function HomeIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  )
}


function LineChartIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 3v18h18" />
      <path d="m19 9-5 5-4-4-3 3" />
    </svg>
  )
}


function Package2Icon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z" />
      <path d="m3 9 2.45-4.9A2 2 0 0 1 7.24 3h9.52a2 2 0 0 1 1.8 1.1L21 9" />
      <path d="M12 3v6" />
    </svg>
  )
}


function PackageIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m7.5 4.27 9 5.15" />
      <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
      <path d="m3.3 7 8.7 5 8.7-5" />
      <path d="M12 22V12" />
    </svg>
  )
}


function SearchIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.3-4.3" />
    </svg>
  )
}


function ShoppingCartIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="8" cy="21" r="1" />
      <circle cx="19" cy="21" r="1" />
      <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
    </svg>
  )
}


function UsersIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  )
}